{
  "helpMessage": "<h3>Ei ni au fesili?</h3>\n<p>Matou te fiafia e fesoasoani - valaʻau mai i le matou 'au:<br/><a><strong>☎️ {{phone}}</strong></a> (ona oomi lea o le <strong>Option 2</strong>)<br/>Aso Gafua i le Aso Faraile, 8am–5pm.</p>",
  "title": "Leai se aogā o le valaaulia"
}
